const campaign = {
  forward: "forward"
};
const data = {
  type: {
    academic: "academic"
  }
};
const display = {
  block: "block",
  feature: "feature",
  featured: "featured",
  hero: "hero",
  image: "image",
  list: "list",
  minimal: "minimal",
  overlay: "overlay",
  promo: "promo",
  short: "short",
  stacked: "stacked",
  standard: "standard",
  statement: "statement",
  sticky: "sticky",
  tabular: "tabular",
  mega: "mega",
  visual: "visual",
  simple: "simple"
};
const layout = {
  center: "center",
  defaultCentered: "default-centered",
  defaultInteriorCentered: "default-interior-centered",
  defaultInterior: "default-interior",
  fixed: "fixed",
  fullImage: "full-image",
  full: "full",
  large: "large",
  small: "small",
  left: "left",
  right: "right",
  stackedInterior: "stacked-interior"
};
const search = {
  domain: "domain"
};
const size = {
  NORMAL: "normal",
  LARGE: "large"
};
const state = {
  CLOSED: "closed",
  FALSE: "false",
  OPENED: "open",
  TRUE: "true"
};
const theme = {
  DARK: "dark",
  GOLD: "gold",
  LIGHT: "light",
  MARYLAND: "maryland"
};
const type = {
  OUTLINE: "outline",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  MEGA: "mega",
  VISUAL: "visual",
  SIMPLE: "simple"
};
const loading = {
  EAGER: "eager",
  LAZY: "lazy"
};
const AttributeValues = {
  campaign,
  data,
  display,
  layout,
  loading,
  search,
  size,
  state,
  theme,
  type
};
export {
  AttributeValues
};
//# sourceMappingURL=values.js.map
